import { render, staticRenderFns } from "./AppointmentDeleted.vue?vue&type=template&id=5cd82b14"
import script from "./AppointmentDeleted.vue?vue&type=script&lang=js"
export * from "./AppointmentDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports